import { render, staticRenderFns } from "./app.password.change.vue?vue&type=template&id=adc62ca0&"
import script from "./app.password.change.vue?vue&type=script&lang=js&"
export * from "./app.password.change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports